import slugify from 'slugify';
import CONFIG from '@/config/config.js';

const GETTERS = {
  GET_INVESTMENT_URL(state) {
    if (state.currentInvestment) {
      return state.currentInvestment.url;
    }
    return null;
  },
  GET_INVESTMENT_BUILDINGS(state) {
    if (state.currentInvestment) {
      return [...state.currentInvestment.buildings].map(
        ([key, building]) => building
      );
    }
    return [];
  },
  IS_MULTI_BUILDING(state) {
    return state.currentInvestment.multiBuilding;
  },
  GET_INVESTMENT_CURRENT_BUILDING(state, getters, rootState) {
    if (
      rootState.route.name === 'flat' ||
      rootState.route.name === 'favourites'
    ) {
      return CONFIG.investments
        .values()
        .next()
        .value.buildings.values()
        .next().value;
    }

    let name = rootState.route.params.building;
    if (!name) {
      throw new Error('Invalid building parameters.');
    }
    return state.currentInvestment.buildings.get(
      slugify(name, { lower: true })
    );
  },
  GET_INVESTMENT_CURRENT_FLOOR(state, getters, rootState) {
    let level = rootState.route.params.floor;
    if (!level) {
      throw new Error('Invalid floor parameters.');
    }
    let building = getters.GET_INVESTMENT_CURRENT_BUILDING;
    if (!building) {
      throw new Error('Invalid building parameters.');
    }
    let floors = building.floors.list;
    for (let floor of floors) {
      if (floor.level == level) {
        return floor;
      }
    }
    return null;
  },
  GET_CURRENT_STREETS(state, getters, rootState) {
    let level = rootState.route.params.floor;
    if (!level) {
      throw new Error('Invalid floor parameters.');
    }
    let building = getters.GET_INVESTMENT_CURRENT_BUILDING;
    if (!building) {
      throw new Error('Invalid building parameters.');
    }
    return building.floors.streets;
  },
  GET_HIGHEST_FLOOR(state, getters, rootState) {
    let level = rootState.route.params.floor;
    if (!level) {
      throw new Error('Invalid floor parameters.');
    }
    let building = getters.GET_INVESTMENT_CURRENT_BUILDING;
    if (!building) {
      throw new Error('Invalid building parameters.');
    }
    let floors = building.floors.list;
    let max = null;
    for (let floor of floors) {
      if (floor.level > max || max == null) {
        max = floor.level;
      }
    }
    return max;
  },
  GET_LOWEST_FLOOR(state, getters, rootState) {
    let level = rootState.route.params.floor;
    if (!level) {
      throw new Error('Invalid floor parameters.');
    }
    let building = getters.GET_INVESTMENT_CURRENT_BUILDING;
    if (!building) {
      throw new Error('Invalid building parameters.');
    }
    let floors = building.floors.list;
    let min = null;
    for (let floor of floors) {
      if (floor.level < min || min == null) {
        min = floor.level;
      }
    }
    return min;
  },
};

export default GETTERS;
